__turbopack_context__.v({
  "section": "shared-module-scss-module__NDvjIq__section",
});
